import { useState } from "react";
import { useBizApiClient } from "../_base/useBizApiClient";
import { useConfigStorage } from "../../../configStorage/useConfigStorage";
import { useSharedStorage } from "../../../sharedStorage/useSharedStorage";
import apiClientOC from "icfrontendapiclient";
import moment from "moment";
const bizApiErrorInterpreter = apiClientOC.get("BizApiErrorInterpreter");
const useArchSnapshotSummaryClient = () => {
  const [result, setResult] = useState({});
  const [getBizapiUrlBase] = useConfigStorage("bizapi_url_base");
  const [cloudAccountId] = useSharedStorage("cac_in_focus_cloud_account_id");
  const [cloudDisplayName] = useSharedStorage("cac_in_focus_cloud_display_name");
  const [sendArchSnapshotSummary] = useBizApiClient({
    name: "archSnapshotSummary",
    method: "get",
    path: `/arch_snapshot/summary/${cloudAccountId}`
  });
  const [sendArchSnapshotAccessTemplate] = useBizApiClient({
    name: "archSnapshotAccessTemplate",
    method: "get",
    path: `/arch_snapshot/access_template/${cloudAccountId}`
  });
  const handleSendRequest = async () => {
    // send summary requests
    const promiseResults = await Promise.all([sendArchSnapshotSummary(), sendArchSnapshotAccessTemplate(), getBizapiUrlBase()]);
    const archSnapshotSummaryResult = promiseResults[0];
    const archSnapshotAccessTemplateResult = promiseResults[1];
    const bizapiUrlBase = promiseResults[2];

    // if one of the summary requests fails, then return that response error
    if (bizApiErrorInterpreter.isError(archSnapshotSummaryResult)) {
      return archSnapshotSummaryResult;
    }
    if (bizApiErrorInterpreter.isError(archSnapshotAccessTemplateResult)) {
      return archSnapshotAccessTemplateResult;
    }

    // create the formatted summary result
    if (archSnapshotSummaryResult.snapshot_access.template.template_version_in_use === '') {
      archSnapshotSummaryResult.message = "In order to generate a snapshot, specific access must be granted using the cloud formation stack provided. When you are done please click confirm.";
    } else if (archSnapshotSummaryResult.snapshot_access.template.template_version_latest !== archSnapshotSummaryResult.snapshot_access.template.template_version_in_use) {
      archSnapshotSummaryResult.message = "A newer version of the cloud formation stack is required in order to generate snapshots. Please follow the launch stack link to update and then click confirm.";
    } else {
      archSnapshotSummaryResult.message = "If you are experiencing issues generating snapshots try updating your cloud formation stack and click confirm when you are done.";
    }
    let formattedSnapshots = archSnapshotSummaryResult.snapshots.map(snapshot => {
      const {
        snapshot_id,
        generation_state,
        generation_state_dt
      } = snapshot.snapshot;

      // if the snapshot is generated, then create the link to the snapshot
      if (snapshot_id && generation_state === "complete") {
        const safeCloudDisplayname = cloudDisplayName.trim().replace(" ", "-").slice(0, 50);
        const genStateDtUTC = moment.utc(generation_state_dt);
        const genStateDt = genStateDtUTC.local();
        const genStateDtDisplay = genStateDt.format("YYYY-M-D_HH-mm-ss");
        const snapshotFileName = `${safeCloudDisplayname}_${snapshot.snapshot.scope_value}_${genStateDtDisplay}`;
        snapshot.snapshot["image_url"] = `${bizapiUrlBase}/arch_snapshot/main_image/${snapshot_id}/${snapshotFileName}`;
      }
      let formattedSnapshot = snapshot.snapshot;
      return formattedSnapshot;
    });
    let nextAvailableGenerationDate = null;
    if (archSnapshotSummaryResult.next_available_generation_date) {
      nextAvailableGenerationDate = archSnapshotSummaryResult.next_available_generation_date;
    }
    let newResult = {
      next_available_generation_date: nextAvailableGenerationDate,
      message: archSnapshotSummaryResult.message,
      accessTemplate: archSnapshotAccessTemplateResult,
      snapshots: formattedSnapshots,
      snapshot_access: archSnapshotSummaryResult.snapshot_access,
      scope_meta: archSnapshotSummaryResult.scope_meta
    };
    setResult(newResult);
    return newResult;
  };
  return [handleSendRequest, result];
};
export { useArchSnapshotSummaryClient };